<template lang="pug">
.bq-dashboard
    //.bq-dash-header
        .bq-dash-title
            span.bq-badge(:class="currentService.formattedSpecs.currentPlan.label.toLowerCase().split(' ')[0]") {{ currentService.formattedSpecs.currentPlan.label }}
            h2.bq-title {{ currentService.service.name }}

    //.bq-section
        //- h2.bq-section-title Project Information

    //- editable fields
    .bq-meta(:class="{ disabled: !user?.email_verified || currentService.service?.will_terminate }")
        h2.bq-section-title {{currentService.service.name}}

        .bq-row
            //- .bq-row-label Service Name
            //- .bq-row-value {{ currentService.service.name }}
            .bq-toggle-label
                span Project Name
                small.bq-toggle-hint(translate="no") {{ currentService.service.name }}
            
            a.bq-link(
                @click="editName"
                :class="{ disabled: !user?.email_verified || currentService.service.active < 0 }"
            ) [Edit]

        //- .bq-row
        //-     .bq-toggle-label
        //-         span CORS
        //-         small.bq-toggle-hint {{ currentService.service.cors || "*" }}
            
        //-     a.bq-link(
        //-         @click="editCors"
        //-         :class="{ disabled: !user?.email_verified || currentService.service.active < 0 }"
        //-     ) [Edit]

        .bq-row
            .bq-toggle-label
                span Base Prompt
                small.bq-toggle-hint(translate="no") {{ currentService.service.description || "No Base Prompt" }}
            
            a.bq-link(
                @click="editDescription"
                :class="{ disabled: !user?.email_verified || currentService.service.active < 0 }"
            ) [Edit]

        //- .bq-toggle-row
        //-     .bq-toggle-label
        //-         span Disable/Enable
        //-         small.bq-toggle-hint When disabled, users cannot access the database.
        //-     Toggle(
        //-         :disabled="!!(currentService.service?.will_terminate || updatingValue.enableDisable)"
        //-         :active="currentService.service.active >= 1"
        //-         @click="enableDisable"
        //-         data-track="service_enableDisable"
        //-     )

        //- .bq-toggle-row
        //-     .bq-toggle-label
        //-         span Allow Signup
        //-         small.bq-toggle-hint When disallowed, only the administrator can create accounts.
        //-     Toggle(
        //-         :active="!currentService.service.prevent_signup"
        //-         :disabled="currentService.service.active < 0 || updatingValue.prevent_signup"
        //-         @click="changeCreateUserMode(!currentService.service.prevent_signup)"
        //-         data-track="service_allowSignup"
        //-     )

        //- .bq-toggle-row
        //-     .bq-toggle-label
        //-         span Prevent Inquiry
        //-         small.bq-toggle-hint When prevented, users cannot send inquiries to this service.
        //-     Toggle(
        //-         :active="currentService.service.prevent_inquiry"
        //-         :disabled="currentService.service.active < 0 || updatingValue.prevent_inquiry"
        //-         @click="changePreventInquiry(!currentService.service.prevent_inquiry)"
        //-         data-track="service_preventInquiry"
        //-     )

        //- prevent_anonymous is a skapi-level flag governing anonymous record
        //- WRITES. BunnyQuery does not surface it: its MCP refuses anonymous
        //- writes unconditionally. The chat's login wall is "Require login" in
        //- Advanced, which is a separate setting.

    .bq-meta

            //- h2.bq-section-title {{ currentService.service.name }}
            h2.bq-section-title Information
            //- span.bq-badge(:class="currentService.formattedSpecs.currentPlan.label.toLowerCase().split(' ')[0]") {{ currentService.formattedSpecs.currentPlan.label }}
            //- h2.bq-title {{ currentService.service.name }}

            .bq-meta-row
                span Project ID
                span.bq-mono(translate="no") {{ currentService.service.projectId }}
            .bq-meta-row
                span Project Owner
                span.bq-mono(translate="no") {{ currentService.service.owner }}
            .bq-meta-row
                span Service ID
                span.bq-mono(translate="no") {{ currentService.service.service }}
            .bq-meta-row
                span Region
                span.bq-mono(translate="no") {{ regionText(currentService.service.region) }}
            .bq-meta-row
                span Created
                span {{ dateFormat(currentService.dateCreated) }}
            //- .bq-meta-row
            //-     span Hosting
            //-     span.bq-mono {{ currentService.service.subdomain ? currentService.service.subdomain + ".bunnyquery.com" : "N/A" }}
            //- .bq-meta-row
            //-     span MCP Endpoint
            //-     //- span.bq-mono {{ MCP_BASE_URL }}
            //-     span.bq-mono
            //-         a.bq-link(
            //-             style="left:0"
            //-             v-if="currentService.service.subdomain"
            //-             :href="MCP_BASE_URL" translate="no"
            //-             target="_blank"
            //-             rel="noopener noreferrer"
            //-         ) {{ MCP_BASE_URL }}
            //- The widget address used to live here, as one grey line among
            //- five. It is now the card at the top of the page, with its own
            //- copy button; a second copy of it here would only compete with it.
            //- .bq-meta-row
            //-     span Email
            //-     span.bq-mono {{ (currentService.service.email_alias || currentService.service.service) + "@mail.skapi.com" }}

    //- //- service ID
    //- .bq-section
    //-     .bq-row
    //-         .bq-row-label Service ID
    //-         .bq-row-value.bq-mono {{ currentService.service.projectId }}
    //-         a.bq-link(@click="copy(currentService.service.projectId)") [Copy]

    //- The project's public chat address. This is the one thing an owner comes
    //- to this page to hand to somebody else, so it leads the page with its own
    //- copy button instead of sitting as a line inside "Information" further
    //- down, where it was easy to miss.
    section.bq-share(v-if="widgetSubdomain")
        .bq-share-head
            span.bq-share-title Chat Widget
            small.bq-share-hint The BunnyQuery chat widget for this project. Share the address so others can chat with your data.
        .bq-share-bar
            a.bq-share-url(
                :href="widgetUrl"
                target="_blank"
                rel="noopener noreferrer"
                translate="no"
                data-track="service_openWidgetLink"
                :class="{ disabled: !widgetLinkLive }"
            ) {{ widgetUrlLabel }}
            .bq-share-actions
                button.bq-share-btn(
                    type="button"
                    @click="copyWidgetLink"
                    data-track="service_copyWidgetLink"
                    :class="{ copied: widgetLinkCopied }"
                )
                    //- Both glyphs are already in index.html's `icon_names=`
                    //- allowlist; a name outside it renders as literal text.
                    span.material-symbols-outlined.bq-share-btn-icon(translate="no") {{ widgetLinkCopied ? 'check_circle' : 'content_copy' }}
                    span {{ widgetLinkCopied ? 'Copied' : 'Copy link' }}
                //- a.bq-share-btn.bq-share-btn--ghost(
                //-     :href="widgetUrl"
                //-     target="_blank"
                //-     rel="noopener noreferrer"
                //-     data-track="service_openWidget"
                //-     :class="{ disabled: !widgetLinkLive }"
                //- ) Open
        small.bq-share-note(v-if="widgetLinkNote") {{ widgetLinkNote }}

    section.bq-share.bq-share--empty(v-else)
        .bq-share-head
            span.bq-share-title Chat Widget
            small.bq-share-hint This project has no chat address yet. The widget link appears here as soon as its subdomain is registered.


    //- plan + usage
    .bq-meta
        h2.bq-section-title Plan &amp; Usage
        .bq-plan-header
            span.bq-badge(:class="currentService.formattedSpecs.currentPlan.label.toLowerCase().split(' ')[0]") {{ currentService.formattedSpecs.currentPlan.label }}
            span.bq-renew(v-if="currentService.subscription?.current_period_end && currentService.formattedSpecs.currentPlan.label.toLowerCase() !== 'free' && currentService.formattedSpecs.serviceStatus.canChangePlan && !currentService.subscription?.will_cancel && !currentService.service?.will_terminate && currentService.subscription?.status !== 'past_due'") Renews {{ dateFormat(currentService.subscription?.current_period_end * 1000) }}

        //- .bq-meta
        //-     .bq-meta-row
        //-         span Project ID
        //-         span.bq-mono {{ currentService.service.projectId }}
        //-     .bq-meta-row
        //-         span Resource
        //-         span.bq-mono {{ currentService.service.service }}
        //-     .bq-meta-row
        //-         span Region
        //-         span.bq-mono {{ currentService.service.region }}
        //-     .bq-meta-row
        //-         span Created
        //-         span {{ dateFormat(currentService.dateCreated) }}
        //-     .bq-meta-row
        //-         span Hosting
        //-         span.bq-mono {{ currentService.service.subdomain ? currentService.service.subdomain + ".skapi.com" : "N/A" }}
        //-     .bq-meta-row
        //-         span Email
        //-         span.bq-mono {{ (currentService.service.email_alias || currentService.service.service) + "@mail.skapi.com" }}

        .bq-usage-bars
            .bq-usage-item
                .bq-usage-head
                    span Users (Collaborators)
                    span {{ currentService.formattedSpecs.serviceStatus.users_string || 0 }} / {{ currentService.formattedSpecs.currentPlan.users_string }}
                .bq-bar
                    .bq-bar-fill(:style="{ width: barWidth(currentService.formattedSpecs.serviceStatus.users_percent) }" :class="barColor(currentService.formattedSpecs.serviceStatus.users_percent)")

            .bq-usage-item
                .bq-usage-head
                    span Database
                    span {{ currentService.formattedSpecs.serviceStatus.storage.database }} / {{ currentService.formattedSpecs.currentPlan.storage.database }}
                .bq-bar
                    .bq-bar-fill(:style="{ width: barWidth(currentService.formattedSpecs.serviceStatus.storage.database_percent) }" :class="barColor(currentService.formattedSpecs.serviceStatus.storage.database_percent)")

            //- One bar for the file pool: hosting, cloud files and the BunnyQuery
            //- index share the plan's ceiling, so they are drawn as three coloured
            //- segments of the same track, and the legend names each share.
            .bq-usage-item
                .bq-usage-head
                    span File Storage
                    span(translate="no") {{ currentService.formattedSpecs.serviceStatus.storage.pool }} / {{ currentService.formattedSpecs.currentPlan.storage.pool }}
                .bq-bar.bq-bar--stacked(:class="poolTrackClass(currentService.formattedSpecs.serviceStatus.storage.pool_percent)")
                    .bq-bar-seg.bq-bar-seg--host(:style="{ width: currentService.formattedSpecs.serviceStatus.storage.segments.host.width }")
                    .bq-bar-seg.bq-bar-seg--cloud(:style="{ width: currentService.formattedSpecs.serviceStatus.storage.segments.cloud.width }")
                    .bq-bar-seg.bq-bar-seg--file(:style="{ width: currentService.formattedSpecs.serviceStatus.storage.segments.file.width }")
                .bq-usage-legend
                    span.bq-legend-item
                        i.bq-legend-dot.bq-bar-seg--host
                        | Hosting
                        span(translate="no") {{ currentService.formattedSpecs.serviceStatus.storage.segments.host.text }}
                    span.bq-legend-item
                        i.bq-legend-dot.bq-bar-seg--cloud
                        | Cloud storage
                        span(translate="no") {{ currentService.formattedSpecs.serviceStatus.storage.segments.cloud.text }}
                    span.bq-legend-item
                        i.bq-legend-dot.bq-bar-seg--file
                        | BunnyQuery storage
                        span(translate="no") {{ currentService.formattedSpecs.serviceStatus.storage.segments.file.text }}

            //- Metered per MONTH, unlike the levels above. Drawn only when the
            //- plan quotes a ceiling: egress_bytes is 0 for Unlimited and NaN
            //- until GET /plan answers, and neither is a bar.
            .bq-usage-item(v-if="currentService.formattedSpecs.currentPlan.egress_bytes > 0")
                .bq-usage-head
                    span Bandwidth (this month)
                    span(translate="no") {{ currentService.formattedSpecs.serviceStatus.usage_month.egress }} / {{ currentService.formattedSpecs.currentPlan.egress }}
                .bq-bar
                    .bq-bar-fill(:style="{ width: barWidth(currentService.formattedSpecs.serviceStatus.usage_month.egress_percent) }" :class="barColor(currentService.formattedSpecs.serviceStatus.usage_month.egress_percent)")

            .bq-usage-item(v-if="currentService.formattedSpecs.currentPlan.email_sends > 0")
                .bq-usage-head
                    span Email sends (this month)
                    span(translate="no") {{ currentService.formattedSpecs.serviceStatus.usage_month.email_sends }} / {{ currentService.formattedSpecs.currentPlan.email_sends_string }}
                .bq-bar
                    .bq-bar-fill(:style="{ width: barWidth(currentService.formattedSpecs.serviceStatus.usage_month.email_sends_percent) }" :class="barColor(currentService.formattedSpecs.serviceStatus.usage_month.email_sends_percent)")

            //- .bq-usage-item
            //-     .bq-usage-head
            //-         span Cloud Storage
            //-         span {{ currentService.formattedSpecs.serviceStatus.storage.cloud }} / {{ currentService.formattedSpecs.currentPlan.storage.cloud }}
            //-     .bq-bar
            //-         .bq-bar-fill(:style="{ width: barWidth(currentService.formattedSpecs.serviceStatus.storage.cloud_percent) }" :class="barColor(currentService.formattedSpecs.serviceStatus.storage.cloud_percent)")

            //- .bq-usage-item
            //-     .bq-usage-head
            //-         span Email Storage
            //-         span {{ currentService.formattedSpecs.serviceStatus.storage.email }} / {{ currentService.formattedSpecs.currentPlan.storage.email }}
            //-     .bq-bar
            //-         .bq-bar-fill(:style="{ width: barWidth(currentService.formattedSpecs.serviceStatus.storage.email_percent) }" :class="barColor(currentService.formattedSpecs.serviceStatus.storage.email_percent)")

            //- .bq-usage-item
            //-     .bq-usage-head
            //-         span Hosting
            //-         span {{ currentService.formattedSpecs.serviceStatus.storage.host }} / {{ currentService.formattedSpecs.currentPlan.storage.host }}
            //-     .bq-bar
            //-         .bq-bar-fill(:style="{ width: barWidth(currentService.formattedSpecs.serviceStatus.storage.host_percent) }" :class="barColor(currentService.formattedSpecs.serviceStatus.storage.host_percent)")
            
            //- The alignment lives on the wrapper, not on the link: as a
            //- right-aligned BLOCK the link stretched the full card width, so
            //- the empty space left of the button was clickable too.
            .bq-plan-cta
                router-link(
                    :to="`/subscription/${currentService.id}`"
                    data-track="service_change_plan"
                )
                    button
                        template(v-if="currentService.subscription?.cancel_at || currentService.service?.will_terminate") Resume Plan
                        template(v-else) Upgrade Plan

        //- What happens past a limit. A plan without a hard stop is billed for
        //- the excess, and the OverageMeter job writes the month to date onto
        //- the service row (service.ovg); a hard stop plan just pauses. Unlimited
        //- has no limits to pass, so it draws neither block.
        .bq-overage(v-if="currentService.formattedSpecs.currentPlan.hard_stop === false && currentService.formattedSpecs.currentPlan.label !== 'Unlimited'")
            h3.bq-overage-title Overage (month to date)
            template(v-if="currentService.formattedSpecs.serviceStatus.overage")
                .bq-meta-row(v-for="row in currentService.formattedSpecs.serviceStatus.overage.rows" :key="row.metric")
                    span {{ row.label }}
                    span(translate="no") {{ row.over }} over, {{ row.cost }}
                .bq-meta-row.bq-overage-total
                    span Total
                    span(translate="no") {{ currentService.formattedSpecs.serviceStatus.overage.total }}
                p.bq-overage-note
                    | {{ currentService.formattedSpecs.serviceStatus.overage.billable ? "Billed with your next invoice" : "Not billed on this plan" }}
                    template(v-if="currentService.formattedSpecs.serviceStatus.overage.sampled")
                        | , sampled 
                        span(translate="no") {{ currentService.formattedSpecs.serviceStatus.overage.sampled }}
            p.bq-overage-note(v-else) No overage recorded yet
        p.bq-overage-note.bq-overage-note--alone(v-else-if="currentService.formattedSpecs.currentPlan.hard_stop !== false") Hard stop: past a limit, uploads and sends pause until you upgrade.
    //- AI Agent API
    .bq-meta(:class="{ disabled: !user?.email_verified || currentService.service?.will_terminate }")
        h2.bq-section-title Query API

        .bq-row
            .bq-toggle-label(style='min-width: 6rem;')
                span AI Platform
            .bq-ai-select(@click.stop="" style='left: -4px;')
                button.bq-ai-select-btn(type="button" @click.prevent="toggleAiPlatformMenu" :class="{ open: aiPlatformMenuOpen }")
                    span.bq-ai-select-value
                        img.bq-ai-logo(v-if="selectedAiPlatform.logo" :src="selectedAiPlatform.logo" :alt="selectedAiPlatform.label")
                        span {{ selectedAiPlatform.label }}
                    span.bq-ai-caret ▾
                select.bq-ai-select-native(v-if="isMobile" v-model="aiPlatform" aria-label="AI Platform")
                    option(value="none") None
                    option(value="openai") ChatGPT
                    option(value="claude") Claude
                .bq-ai-options(v-if="!isMobile && aiPlatformMenuOpen")
                    button.bq-ai-option(
                        v-for="option in aiPlatformOptions"
                        :key="option.value"
                        type="button"
                        @click="selectAiPlatform(option.value)"
                        :class="{ active: aiPlatform === option.value }"
                    )
                        img.bq-ai-logo(v-if="option.logo" :src="option.logo" :alt="option.label")
                        span {{ option.label }}

        .bq-row(:class="{ disabled: aiPlatform === 'none' || fetchingAiModels || !aiModels.length }")
            .bq-toggle-label(style='min-width: 6rem;')
                span Model
            .bq-ai-select(@click.stop="" style='left: -4px;')
                button.bq-ai-select-btn(type="button" @click.prevent="toggleModelMenu" :disabled="fetchingAiModels" :class="{ open: modelMenuOpen }")
                    span.bq-ai-select-value
                        span(v-if="fetchingAiModels") Loading...
                        span(v-else-if="aiModelsError && aiPlatform !== 'none'") Invalid API Key
                        span(v-else-if="!aiModels.length && aiPlatform !== 'none'") No models
                        span(v-else translate="no") {{ selectedModelLabel }}
                    span.bq-ai-caret ▾
                select.bq-ai-select-native(v-if="isMobile && aiModels.length" :value="selectedModel" @change="selectModel($event.target.value)" :disabled="fetchingAiModels" aria-label="AI Model")
                    option(v-for="m in aiModels" :key="m.id" :value="m.id" translate="no") {{ m.display_name || m.id }}
                .bq-ai-options.bq-model-options(v-if="!isMobile && modelMenuOpen")
                    button.bq-ai-option(
                        v-for="m in aiModels"
                        :key="m.id"
                        type="button"
                        @click="selectModel(m.id)"
                        :class="{ active: selectedModel === m.id }"
                    )
                        span(translate="no") {{ m.display_name || m.id }}

        .bq-row(:class="{ disabled: aiPlatform === 'none' || !selectedModel }")
            .bq-toggle-label(style='min-width: 6rem;')
                span Input Context
                small.bq-toggle-hint How much conversation history each message may carry.
            .bq-ai-select(@click.stop="" style='left: -4px;')
                button.bq-ai-select-btn(type="button" @click.prevent="toggleContextMenu" :disabled="!selectedModel" :class="{ open: contextMenuOpen }")
                    span.bq-ai-select-value
                        span(translate="no") {{ selectedContextLabel }}
                    span.bq-ai-caret ▾
                select.bq-ai-select-native(
                    v-if="isMobile && selectedModel"
                    :value="selectedContextWindow === null ? '' : String(selectedContextWindow)"
                    @change="selectContextWindow($event.target.value)"
                    aria-label="Context window"
                )
                    option(v-for="o in contextWindowOptions" :key="o.label" :value="o.value === null ? '' : String(o.value)" translate="no") {{ o.label }}
                .bq-ai-options(v-if="!isMobile && contextMenuOpen")
                    button.bq-ai-option(
                        v-for="o in contextWindowOptions"
                        :key="o.label"
                        type="button"
                        @click="selectContextWindow(o.value)"
                        :class="{ active: selectedContextWindow === o.value }"
                    )
                        span(translate="no") {{ o.label }}

        .bq-row.bq-api-key-row(:class="{ disabled: aiPlatform === 'none' }")
            .bq-toggle-label
                span API Key
                small.bq-toggle-hint.bq-api-key-value
                    span.bq-api-key-slot(v-if="fetchingAiApiKey")
                        span.bq-loader Loading
                    span.bq-api-key-slot(v-else translate="no") {{ aiApiKey ? aiApiKey.slice(0, 2) + '******...' : 'Not set' }}
            a.bq-link(
                @click="editAiApiKey"
                :class="{ disabled: aiPlatform === 'none' || fetchingAiApiKey || loadingAiApiKey }"
            ) <span v-if="loadingAiApiKey">[{{ aiApiKeyLoadingDots }}]</span><span v-else>[Edit]</span>

    //- Advanced (expert tools)
    .bq-meta(:class="{ disabled: !user?.email_verified || currentService.service?.will_terminate }")
        h2.bq-section-title Advanced

        .bq-row
            .bq-toggle-label
                span Database
                small.bq-toggle-hint Browse and edit records in this project's database.
            router-link.bq-link(
                :to="`/my-projects/${currentService.id}/records`"
                data-track="service_openDatabase"
                :class="{ disabled: !user?.email_verified || currentService.service.active < 0 }"
            ) [Open]

        //- The chat page this project serves at <subdomain>. Its version is not
        //- stored anywhere per service, so it is scraped from the hosted HTML.
        .bq-row
            .bq-toggle-label
                span Chat Widget Version
                small.bq-toggle-hint(v-if="widgetError" translate="no") {{ widgetError }}
                small.bq-toggle-hint(v-else translate="no") {{ widgetVersionLabel }}
            a.bq-link(
                @click="updateWidget"
                :class="{ disabled: !canUpdateWidget }"
                data-track="service_updateWidget"
            )
                span(v-if="updatingValue.widget") [Updating]
                span(v-else) [Update]

        //- The line the chat opens with, held in the SAME "bq::settings" record
        //- as the "Default access" setting (its own `chat_greeting` key, so one
        //- fetch reads both, wherever the two rows sit on the page). Empty means
        //- the built-in sentence, which is what every project had before this
        //- setting existed, so a project that never opens this is unchanged.
        .bq-row
            .bq-toggle-label
                span Chat Intro
                //- Until the settings record has been read, "" is indistinguishable
                //- from "this project has never set one", and the row would state
                //- "Default intro message" as though that were the fetched answer.
                //- Say we are still looking instead, and hold Edit shut: opening it
                //- early would put an empty textarea in front of an owner who does
                //- have a custom line, and saving that would wipe it.
                small.bq-toggle-hint(v-if="!projectSettingsLoaded") Loading...
                small.bq-toggle-hint(v-else translate="no") {{ chatGreetingLabel }}

            a.bq-link(
                @click="editChatGreeting"
                :class="{ disabled: !projectSettingsLoaded || !user?.email_verified || currentService.service.active < 0 }"
            ) [Edit]

        .bq-toggle-row
            .bq-toggle-label
                span Freeze Database
                small.bq-toggle-hint When frozen, the database cannot be modified by non-admin users.
            Toggle(
                :active="currentService.service.freeze_database"
                :disabled="currentService.service.active < 0 || updatingValue.freeze_database"
                @click="changeFreezeDatabase(!currentService.service.freeze_database)"
                :data-track="`service_freezeDatabase_${currentService.service.freeze_database ? 'unfreeze' : 'freeze'}`"
            )

        .bq-toggle-row
            .bq-toggle-label
                span Allow Signup
                small.bq-toggle-hint When allowed, users can create account to your BunnyQuery chat.
            Toggle(
                :active="!currentService.service.prevent_signup"
                :disabled="currentService.service.active < 0 || updatingValue.prevent_signup"
                @click="changeCreateUserMode(!currentService.service.prevent_signup)"
                data-track="service_allowSignup"
            )

        //- The access group an uploaded file's records are written at, held in a
        //- record of the project's own database ("bq::settings"), not on the
        //- service record. Sits beside "Allow anonymous users" because the two
        //- decide the same thing together: an anonymous visitor can only ever
        //- read records at the "Public" group.
        //- Disabled until the settings record has been read, so the control can
        //- never show a value it has not actually fetched.
        .bq-row
            .bq-toggle-label(style='min-width: 6rem;')
                span Default access
                small.bq-toggle-hint Access group for the files you upload, and for everything BunnyQuery indexes out of them.
            .bq-ai-select(@click.stop="" style='left: -4px;')
                button.bq-ai-select-btn(type="button" @click.prevent="toggleUploadAccessMenu" :disabled="updatingValue.uploadAccess || !projectSettingsLoaded" :class="{ open: uploadAccessMenuOpen }")
                    span.bq-ai-select-value
                        span {{ uploadAccessLabel }}
                    span.bq-ai-caret ▾
                select.bq-ai-select-native(
                    v-if="isMobile"
                    :value="uploadAccessSetting"
                    :disabled="updatingValue.uploadAccess || !projectSettingsLoaded"
                    @change="selectUploadAccessGroup($event.target.value)"
                    aria-label="Default access"
                )
                    option(v-for="o in uploadAccessOptions" :key="o.value" :value="o.value") {{ o.label }}
                .bq-ai-options(v-if="!isMobile && uploadAccessMenuOpen")
                    button.bq-ai-option(
                        v-for="o in uploadAccessOptions"
                        :key="o.value"
                        type="button"
                        @click="selectUploadAccessGroup(o.value)"
                        :class="{ active: uploadAccessSetting === o.value }"
                    )
                        span {{ o.label }}

        //- Whether the embeddable chat opens on the login page or straight into
        //- the chat. Read by the widget from getConnectionInfo().conf.
        //- Deliberately NOT prevent_anonymous: that flag governs anonymous record
        //- WRITES at the skapi layer, which the BunnyQuery MCP refuses outright
        //- regardless, and it has never gated reading public records.
        .bq-toggle-row
            .bq-toggle-label
                span Require login
                small.bq-toggle-hint(v-if="anonymousKeyWarning") {{ anonymousKeyWarning }}
                small.bq-toggle-hint(v-else) When off, visitors can use your chat without an account. They can only read your public records, and can never write.
            Toggle(
                :active="requireLogin"
                :disabled="currentService.service.active < 0 || updatingValue.require_login"
                @click="changeRequireLogin(!requireLogin)"
                data-track="service_requireLogin"
            )
        //- .bq-toggle-row
        //-     .bq-toggle-label
        //-         span Allow Signup
        //-         small.bq-toggle-hint When disallowed, only the administrator can create accounts.
        //-     Toggle(
        //-         :active="!currentService.service.prevent_signup"
        //-         :disabled="currentService.service.active < 0 || updatingValue.prevent_signup"
        //-         @click="changeCreateUserMode(!currentService.service.prevent_signup)"
        //-         data-track="service_allowSignup"
        //-     )
    //- delete
    .bq-section(v-if="canDeleteService" style="text-align:right")
        router-link.bq-link.bq-danger(
            :to="'/delete-service/' + currentService.id"
            :class="{ disabled: !user?.email_verified || currentService.service.active == 0 }"
        ) [Delete Project]

    //- modals
    Modal(:open="modifyMode.name" @close="() => { if (!updatingValue.name) modifyMode.name = false }")
        .bq-modal-wrap
            .bq-modal-close(@click="modifyMode.name = false" :class="{ disabled: updatingValue.name }") &times;
            form.bq-modal-step(@submit.prevent="changeName")
                h2 Change Service Name
                p.bq-modal-desc Enter a new name for the service (max 40 characters).
                input.bq-modal-input(
                    type="text"
                    ref="focus_name"
                    placeholder="Max 256 characters"
                    maxlength="256"
                    :value="inputName"
                    @input="e => inputName = e.target.value"
                    :disabled="updatingValue.name"
                    required
                )
                button.btn(
                    type="submit"
                    data-track="service_changeNameModal_save"
                    :class="{ 'bq-btn--loading': updatingValue.name }"
                )
                    span.bq-loader(v-if="updatingValue.name")
                    template(v-else) Save

    Modal(:open="modifyMode.cors" @close="() => { if (!updatingValue.cors) modifyMode.cors = false }")
        .bq-modal-wrap
            .bq-modal-close(@click="modifyMode.cors = false" :class="{ disabled: updatingValue.cors }") &times;
            form.bq-modal-step(@submit.prevent="changeCors")
                h2 CORS
                p.bq-modal-desc When set, this service will only accept requests from the specified origins.
                p.bq-modal-desc Comma separated origins. Leave empty to allow every origin.
                input#modifyCors.bq-modal-input(
                    ref="focus_cors"
                    :disabled="updatingValue.cors || null"
                    type="text"
                    placeholder="https://your.domain.com, ..."
                    :value="inputCors"
                    @input="e => { e.target.setCustomValidity(''); inputCors = e.target.value; }"
                )
                button.btn(
                    type="submit"
                    data-track="service_changeCorsModal_save"
                    :class="{ 'bq-btn--loading': updatingValue.cors }"
                )
                    span.bq-loader(v-if="updatingValue.cors")
                    template(v-else) Save

    Modal(:open="modifyMode.description" @close="() => { if (!updatingValue.description) modifyMode.description = false }")
        .bq-modal-wrap
            .bq-modal-close(@click="modifyMode.description = false" :class="{ disabled: updatingValue.description }") &times;
            form.bq-modal-step(@submit.prevent="changeDescription")
                h2 Base Prompt
                p.bq-modal-desc Add a short description or base prompt for your project. This can be used to provide default context to AI.
                textarea.bq-modal-textarea(
                    ref="focus_description"
                    :disabled="updatingValue.description || null"
                    placeholder="Describe your project..."
                    maxlength="1000"
                    rows="4"
                    :value="inputDescription"
                    @input="e => inputDescription = e.target.value"
                )
                button.btn(
                    type="submit"
                    data-track="service_changeDescriptionModal_save"
                    :class="{ 'bq-btn--loading': updatingValue.description }"
                )
                    span.bq-loader(v-if="updatingValue.description")
                    template(v-else) Save

    Modal(:open="modifyMode.chatGreeting" @close="() => { if (!updatingValue.chatGreeting) modifyMode.chatGreeting = false }")
        .bq-modal-wrap
            .bq-modal-close(@click="modifyMode.chatGreeting = false" :class="{ disabled: updatingValue.chatGreeting }") &times;
            form.bq-modal-step(@submit.prevent="changeChatGreeting")
                h2 Chat Intro
                p.bq-modal-desc The first message your chat opens with, in your own words. It replaces the default line for everyone who opens this project's chat, including the embedded widget. The assistant is also told this is what it opened with, so it can answer questions about it.
                p.bq-modal-desc Leave it empty to go back to the default intro.
                textarea.bq-modal-textarea(
                    ref="focus_chatGreeting"
                    :disabled="updatingValue.chatGreeting || null"
                    placeholder="Hi! Start by attaching the files related to your project..."
                    :maxlength="CHAT_GREETING_MAX_LENGTH"
                    rows="4"
                    :value="inputChatGreeting"
                    @input="e => inputChatGreeting = e.target.value"
                )
                button.btn(
                    type="submit"
                    data-track="service_changeChatGreetingModal_save"
                    :class="{ 'bq-btn--loading': updatingValue.chatGreeting }"
                )
                    span.bq-loader(v-if="updatingValue.chatGreeting")
                    template(v-else) Save

    Modal(:open="modifyMode.aiApiKey" @close="() => { if (!updatingValue.aiApiKey) modifyMode.aiApiKey = false }")
        .bq-modal-wrap
            .bq-modal-close(@click="modifyMode.aiApiKey = false" :class="{ disabled: updatingValue.aiApiKey }") &times;
            form.bq-modal-step(@submit.prevent="saveAiApiKey")
                h2 API Key
                p.bq-modal-desc Enter your {{ aiPlatform === 'claude' ? 'Claude' : 'OpenAI' }} API key.
                textarea.bq-modal-textarea(
                    ref="focus_aiApiKey"
                    :disabled="updatingValue.aiApiKey || null"
                    placeholder="sk-..."
                    :value="inputAiApiKey"
                    @input="e => inputAiApiKey = e.target.value"
                    rows="3"
                )
                button.btn(
                    type="submit"
                    data-track="service_saveAiApiKeyModal_save"
                    :class="{ 'bq-btn--loading': updatingValue.aiApiKey }"
                )
                    span.bq-loader(v-if="updatingValue.aiApiKey")
                    template(v-else) Save
</template>

<script setup lang="ts">
import { useRoute, useRouter } from "vue-router";
import { computed, nextTick, onMounted, onUnmounted, reactive, ref, watch } from "vue";
import { currentService, serviceClientSecrets, aiModelCache, aiApiKeyCache, aiApiKeyInflight, saveAiApiKeyPrivately, loadAiApiKeyPrivately } from "@/views/project-list";
import { SkapiError } from "skapi-js";
import {
    DEFAULT_CLAUDE_MODEL, DEFAULT_OPENAI_MODEL,
    parseAiAgentValue, buildAiAgentValue as engineBuildAiAgentValue,
    getModelContextWindow, registerModelContextWindows, DEFAULT_CONTEXT_WINDOW,
} from "@/code/ai_agent";
import { loadModelCatalogue, apiKeyRejected, invalidateApiKeyVerdict } from "@/code/ai_models";
import { dateFormat } from "@/code/utils";
import { skapi } from "@/main";
import { user } from "@/code/user";
import Modal from "@/components/modal.vue";
import Toggle from "@/components/toggle.vue";
import { removeFullScreenLoader } from "@/components/jsComponents";
import chatgptLogo from "@/assets/img/logo/ChatGPT-Logo.png";
import claudeLogo from "@/assets/img/logo/claude-ai-symbol.svg";
import { MCP_BASE_URL } from "@/code/mcp_oauth";
import { readHostedWidget, fetchLatestWidgetTemplate, updateHostedWidget } from "@/code/widget_update";
import { hostDomain, aiClientSecretGrp } from "@/code/service";
import { regionLabel } from "@/code/regions";
import {
    UPLOAD_ACCESS_OPTIONS, UPLOAD_ACCESS_LABELS, DEFAULT_UPLOAD_ACCESS_GROUP,
    CHAT_GREETING_MAX_LENGTH, normalizeChatGreeting, chatGreetingFrom,
    normalizeUploadAccessGroup, projectAccessSetting,
    PROJECT_SETTINGS_TABLE, PROJECT_SETTINGS_UNIQUE_ID, PROJECT_SETTINGS_ACCESS_GROUP,
    readyProjectSettings, patchProjectSettings, cachedProjectSettings,
    type ProjectAccessSetting, type ProjectSettingsData,
} from "@/code/access_group";

const router = useRouter();
const route = useRoute();

// The region is picked by city when a project is created, so name it here too
// rather than leaving the reader to decode "eu-west-3". Falls back to the bare
// code for a region the catalogue does not know.
const regionText = (region: string): string => {
    let label = regionLabel(region);
    return label && label !== region ? `${region} (${label})` : region || "";
};

let inputName = "";
let inputCors = "";
let inputDescription = "";
let modifyMode = reactive({
    name: false,
    cors: false,
    description: false,
    aiApiKey: false,
    chatGreeting: false,
});
// Shown under the "Allow anonymous users" row when the flag saved but the AI
// key's access group did not follow it, which leaves the toggle telling the
// owner something the backend does not agree with.
let anonymousKeyWarning = ref("");

let updatingValue = reactive({
    name: false,
    cors: false,
    description: false,
    prevent_signup: false,
    enableDisable: false,
    prevent_inquiry: false,
    freeze_database: false,
    require_login: false,
    aiApiKey: false,
    widget: false,
    uploadAccess: false,
    chatGreeting: false,
});

/* ─── hosted chat widget (Advanced > Chat Widget) ─── */
// The version the project is serving right now, scraped from its hosted
// index.html, and the version the published template would install. Both are
// null until the probe lands; `widgetProbed` separates "still looking" from
// "looked, and there is no page".
let hostedWidgetVersion = ref<string | null>(null);
let hostedWidgetPresent = ref(false);
let latestWidgetVersion = ref<string | null>(null);
let widgetProbed = ref(false);
let widgetError = ref("");

let widgetVersionLabel = computed(() => {
    if (!widgetProbed.value) return "Checking...";
    if (!hostedWidgetPresent.value) return "No page published yet";

    const cur = hostedWidgetVersion.value;
    const latest = latestWidgetVersion.value;
    if (!cur) return latest ? `Unknown version (latest v${latest})` : "Unknown version";
    if (!latest) return `v${cur}`;
    return cur === latest ? `v${cur} (up to date)` : `v${cur} (latest v${latest})`;
});

// Whether the published page already IS the latest template, which is the one
// case where there is nothing for the button to do. It takes both versions
// being known and equal: a project with no page yet still needs its first
// publish, and an unknown version on either side (an unreadable page, an
// unreachable template) is not a match -- in both of those the update is still
// the useful move, so the button stays live.
let widgetUpToDate = computed(
    () =>
        widgetProbed.value &&
        hostedWidgetPresent.value &&
        !!hostedWidgetVersion.value &&
        !!latestWidgetVersion.value &&
        hostedWidgetVersion.value === latestWidgetVersion.value,
);

// The update writes index.html into the project's subdomain folder, so it needs
// a settled subdomain. `pending.cdn` is excluded too: refreshCDN would refuse
// while a previous invalidation is still in flight, and the update ends in one.
// Deliberately NOT gated on the probe having landed: neither probe read carries
// a timeout, so a hung fetch would leave the row on "Checking..." with a dead
// button. While the versions are unknown the update stays available, exactly as
// before; only a known match takes it away.
let canUpdateWidget = computed(() => {
    const sd = currentService.value?.service?.subdomain;
    return !!(
        user?.email_verified &&
        sd &&
        !"+*!".includes(sd[0]) &&
        currentService.value?.service?.active >= 0 &&
        !currentService.value?.pending?.cdn &&
        !updatingValue.widget &&
        !widgetUpToDate.value
    );
});

let probeWidgetVersions = async () => {
    widgetError.value = "";
    // Both reads are independent and started together; a failure to reach the
    // published template must not hide the version the project is actually
    // serving, which is the part this row exists to show. Each settles into its
    // own value rather than rejecting, so neither can cancel the other.
    const hostedPromise = readHostedWidget(currentService.value).then(
        (r) => ({ ok: true, r }),
        (e) => ({ ok: false, e }),
    );
    const latestPromise = fetchLatestWidgetTemplate().then(
        (r) => ({ ok: true, r }),
        (e) => ({ ok: false, e }),
    );

    try {
        const hosted: any = await hostedPromise;
        if (hosted.ok) {
            hostedWidgetPresent.value = hosted.r.hosted;
            hostedWidgetVersion.value = hosted.r.version;
        } else {
            widgetError.value = errText(hosted.e);
        }

        const latest: any = await latestPromise;
        if (latest.ok) latestWidgetVersion.value = latest.r.version;
    } finally {
        widgetProbed.value = true;
    }
};

let updateWidget = async () => {
    if (!canUpdateWidget.value) return;

    updatingValue.widget = true;
    widgetError.value = "";
    try {
        const res = await updateHostedWidget(currentService.value);
        hostedWidgetPresent.value = true;
        hostedWidgetVersion.value = res.version;
        if (res.version) latestWidgetVersion.value = res.version;
        if (!res.refreshed) {
            // The bytes are in the bucket; only the invalidation did not queue.
            // Say so rather than reporting a clean success the visitor will not
            // see for up to a day.
            widgetError.value = "Page updated. The CDN refresh did not queue, retry it from Hosting.";
        }
    } catch (err: any) {
        widgetError.value = errText(err);
    } finally {
        updatingValue.widget = false;
    }
};

let errText = (err: any) =>
    (typeof err === "string" ? err : err?.message) || "Something went wrong.";

/* ─── the project's public chat link (the card at the top of the page) ─── */
// A subdomain carries a one-character status flag while it is in transit
// ('+new'), being released ('*old') or held ('!old'). The flag is bookkeeping,
// not part of the address, so it is stripped before the link is drawn -- the
// buried row this card replaced printed it verbatim and showed people a
// "+myproject.bunnyquery.com" they could neither open nor share.
let widgetSubdomain = computed(() => {
    const sd = currentService.value?.service?.subdomain || "";
    if (!sd) return "";
    return "+*!".includes(sd[0]) ? sd.slice(1) : sd;
});

let widgetUrlLabel = computed(() =>
    widgetSubdomain.value ? `${widgetSubdomain.value}.${hostDomain}` : "",
);

let widgetUrl = computed(() =>
    widgetUrlLabel.value ? `https://${widgetUrlLabel.value}` : "",
);

// Whether the address is serving right now. A flagged subdomain still has a
// readable address worth copying, but opening it would land on nothing yet, so
// only the live case gets a working [Open].
let widgetLinkLive = computed(() => {
    const sd = currentService.value?.service?.subdomain || "";
    return !!sd && !"+*!".includes(sd[0]);
});

let widgetLinkNote = computed(() => {
    const sd = currentService.value?.service?.subdomain || "";
    if (!sd) return "";
    if (sd[0] === "+") return "This address is still being set up. It goes live in a few minutes.";
    if (sd[0] === "*") return "This address is being released and will stop working.";
    if (sd[0] === "!") return "This address is on hold.";
    // A settled address with nothing published behind it answers a visitor with
    // a 404, so say so here rather than letting someone share a dead link. Only
    // once the probe has actually landed AND came back clean: a probe that could
    // not reach the page leaves `hostedWidgetPresent` false too, and reporting
    // that as "nothing published" would be a lie about a working widget.
    if (widgetProbed.value && !widgetError.value && !hostedWidgetPresent.value)
        return "No chat page is published at this address yet. Publish it from Advanced > Chat Widget.";
    return "";
});

let widgetLinkCopied = ref(false);
let widgetCopyTimer: ReturnType<typeof setTimeout> | null = null;

let copyWidgetLink = async () => {
    const url = widgetUrl.value;
    if (!url) return;

    try {
        await navigator.clipboard.writeText(url);
    } catch {
        // navigator.clipboard is absent over plain http and inside some embedded
        // browsers, and rejects when the document is not focused. The hidden
        // textarea still copies in all of those.
        const ta = document.createElement("textarea");
        ta.value = url;
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        ta.remove();
    }

    widgetLinkCopied.value = true;
    if (widgetCopyTimer) clearTimeout(widgetCopyTimer);
    widgetCopyTimer = setTimeout(() => {
        widgetLinkCopied.value = false;
    }, 1600);
};
let focus_name = ref();
let focus_cors = ref();
let focus_description = ref();
let focus_chatGreeting = ref();
let focus_aiApiKey = ref();

let aiPlatform = ref('none');
let aiApiKey = ref('');
let inputAiApiKey = '';
let fetchingAiApiKey = ref(false);
let loadingAiApiKey = ref(false);
let aiApiKeyLoadingDots = ref('.');
let aiApiKeyLoadingDotsTimer: ReturnType<typeof setInterval> | null = null;
const startAiApiKeyDots = () => {
    if (aiApiKeyLoadingDotsTimer) return;
    let n = 0;
    aiApiKeyLoadingDots.value = '.';
    aiApiKeyLoadingDotsTimer = setInterval(() => {
        n = (n + 1) % 3;
        aiApiKeyLoadingDots.value = '.'.repeat(n + 1);
    }, 350);
};
const stopAiApiKeyDots = () => {
    if (aiApiKeyLoadingDotsTimer) {
        clearInterval(aiApiKeyLoadingDotsTimer);
        aiApiKeyLoadingDotsTimer = null;
    }
};
let aiPlatformMenuOpen = ref(false);
let isMobile = ref(false);

let aiModels = ref<any[]>([]);
let fetchingAiModels = ref(false);
let aiModelsError = ref(false);
let selectedModel = ref('');
let modelMenuOpen = ref(false);
let aiPlatformFetchToken = 0;

type AiPlatform = 'none' | 'claude' | 'openai';

// ChatGPT leads the list so it reads as the house default; Claude follows.
// Keep this order in sync with agent.vue / dbfile.vue's platformOptions.
const aiPlatformOptions: { value: AiPlatform; label: string; logo?: string }[] = [
    { value: 'none', label: 'None' },
    { value: 'openai', label: 'ChatGPT', logo: chatgptLogo },
    { value: 'claude', label: 'Claude', logo: claudeLogo },
];

const selectedAiPlatform = computed(() => {
    return aiPlatformOptions.find(o => o.value === aiPlatform.value) || aiPlatformOptions[0];
});

const toggleAiPlatformMenu = () => {
    if (isMobile.value) return;
    modelMenuOpen.value = false;
    aiPlatformMenuOpen.value = !aiPlatformMenuOpen.value;
};

const selectAiPlatform = (value: AiPlatform) => {
    aiPlatformMenuOpen.value = false;
    aiPlatform.value = value;
};

const closeAiPlatformMenu = () => {
    aiPlatformMenuOpen.value = false;
};

const selectedModelLabel = computed(() => {
    if (!selectedModel.value) return 'Select model';
    let m = aiModels.value.find(m => m.id === selectedModel.value);
    return m?.display_name || m?.id || selectedModel.value;
});

const toggleModelMenu = () => {
    if (isMobile.value) return;
    aiPlatformMenuOpen.value = false;
    contextMenuOpen.value = false;
    modelMenuOpen.value = !modelMenuOpen.value;
};

// --- Context window -------------------------------------------------------
// Per-project override of how much context the chat may use. Stored as the
// third segment of `ai_agent` and applied by the engine's getContextWindow.
// Without an override a project runs at DEFAULT_CONTEXT_WINDOW (clamped to the
// model), so "Default" here names a real number rather than a legacy behavior.
const contextMenuOpen = ref(false);
const selectedContextWindow = ref<number | null>(
    parseAiAgentValue(currentService.value?.service?.ai_agent).contextWindow
);

// One list for every platform. Which entries actually appear is decided by the
// selected model's ceiling below, not by the platform.
const CONTEXT_WINDOW_PRESETS = [32000, 64000, 128000, 200000, 400000, 880000, 1000000];

const fmtTokens = (n: number) => n >= 1000000
    ? (n % 1000000 === 0 ? n / 1000000 + 'M' : (n / 1000000).toFixed(1) + 'M')
    : Math.round(n / 1000) + 'K';

/** The model's hard ceiling: the largest window it can be asked for at all. */
const modelContextCeiling = computed(() => {
    if (aiPlatform.value === 'none') return 0;
    return getModelContextWindow(aiPlatform.value, selectedModel.value || undefined) || 0;
});

/**
 * What "Default" resolves to for this model. Normally DEFAULT_CONTEXT_WINDOW,
 * but clamped for a model whose ceiling is lower than it (claude-opus-4-5 and
 * claude-haiku-4-5 are 200K), so the label never promises more than it delivers.
 */
const effectiveDefaultWindow = computed(() => {
    const ceiling = modelContextCeiling.value;
    return ceiling ? Math.min(DEFAULT_CONTEXT_WINDOW, ceiling) : 0;
});

// Never offer a window larger than the model actually has: the request would be
// rejected by the provider, and the point of the control is to spend the
// model's context, not to invent more of it. This is also why the shared preset
// list is safe across platforms — gpt-5.6-luna tops out at 922K, so it is
// offered everything up to 880K and never the 1M entry.
const contextWindowOptions = computed(() => {
    const max = modelContextCeiling.value;
    const dflt = effectiveDefaultWindow.value;
    const opts: Array<{ label: string; value: number | null }> = [
        { label: dflt ? `Default (${fmtTokens(dflt)})` : 'Default', value: null },
    ];
    for (const preset of CONTEXT_WINDOW_PRESETS) {
        if (max && preset <= max) opts.push({ label: fmtTokens(preset), value: preset });
    }
    return opts;
});

const selectedContextLabel = computed(() => {
    const current = selectedContextWindow.value;
    if (!current) return contextWindowOptions.value[0].label;
    return fmtTokens(current);
});

const toggleContextMenu = () => {
    if (isMobile.value) return;
    aiPlatformMenuOpen.value = false;
    modelMenuOpen.value = false;
    contextMenuOpen.value = !contextMenuOpen.value;
};

const closeContextMenu = () => {
    contextMenuOpen.value = false;
};

const selectContextWindow = async (raw: number | string | null) => {
    contextMenuOpen.value = false;
    const parsed = raw === null || raw === '' ? null : Number(raw);
    const next = parsed && Number.isFinite(parsed) && parsed > 0 ? Math.floor(parsed) : null;
    const previous = selectedContextWindow.value;
    selectedContextWindow.value = next;
    try {
        await currentService.value.setServiceOption({
            ai_agent: engineBuildAiAgentValue(aiPlatform.value, selectedModel.value, next),
        });
    } catch (err) {
        selectedContextWindow.value = previous;
        throw err;
    }
};

const selectModel = async (modelId: string) => {
    modelMenuOpen.value = false;
    selectedModel.value = modelId;
    // Carry the context override across a model change, but clamp it: the new
    // model may have a smaller window than the old one, and an override above
    // it would build a request the provider rejects.
    const newModelMax = getModelContextWindow(aiPlatform.value, modelId) || 0;
    if (selectedContextWindow.value && newModelMax && selectedContextWindow.value > newModelMax) {
        selectedContextWindow.value = null;
    }
    await currentService.value.setServiceOption({
        ai_agent: engineBuildAiAgentValue(aiPlatform.value, modelId, selectedContextWindow.value),
    });
};

const closeModelMenu = () => {
    modelMenuOpen.value = false;
    contextMenuOpen.value = false;
};

const syncMobile = () => {
    isMobile.value = window.matchMedia('(max-width: 600px)').matches;
    if (isMobile.value) {
        aiPlatformMenuOpen.value = false;
        modelMenuOpen.value = false;
        contextMenuOpen.value = false;
    }
};



async function fetchAiModels(platform: 'claude' | 'openai', token: number) {
    let savedAgent = currentService.value.service.ai_agent || '';
    let savedModel = savedAgent.includes('#') ? savedAgent.split('#')[1] : '';

    fetchingAiModels.value = true;
    aiModelsError.value = false;

    const platformDefault = platform === 'claude' ? DEFAULT_CLAUDE_MODEL : DEFAULT_OPENAI_MODEL;

    // Apply a fetched-or-cached model list and reconcile the saved/selected
    // model. If the saved model is missing from the list, fall back to the
    // platform default (or first available) and persist the change.
    const applyModels = async (models: any[]) => {
        aiModels.value = models;
        // Anthropic's /v1/models reports max_input_tokens per model, which is the
        // authoritative context window. OpenAI's listing has no equivalent, so
        // this is a no-op there and those models fall back to the static table.
        registerModelContextWindows(models);

        if (!models.length) {
            selectedModel.value = '';
            return;
        }

        if (savedModel && models.some((m: any) => m.id === savedModel)) {
            selectedModel.value = savedModel;
            return;
        }

        const fallback =
            (platformDefault && models.some((m: any) => m.id === platformDefault) && platformDefault) ||
            models[0]?.id ||
            '';

        selectedModel.value = fallback;
        if (fallback) {
            await currentService.value.setServiceOption({ ai_agent: `${platform}#${fallback}` });
        } else if (savedModel) {
            await currentService.value.setServiceOption({ ai_agent: platform });
        }
    };

    if (aiModelCache[platform]) {
        if (token !== aiPlatformFetchToken || aiPlatform.value !== platform) {
            return;
        }

        await applyModels(aiModelCache[platform]);

        if (token === aiPlatformFetchToken) {
            fetchingAiModels.value = false;
        }
        return;
    }

    try {
        let serviceId = currentService.value.id;
        let owner = currentService.value.owner;
        // The list comes from the STATIC catalogue (see @/code/ai_models): the
        // provider's listing call cost seconds through the queue+proxy to fill
        // a dropdown that changes a few times a year.
        let models = await loadModelCatalogue(platform);

        if (token !== aiPlatformFetchToken || aiPlatform.value !== platform) {
            return;
        }

        aiModelCache[platform] = models;
        await applyModels(models);

        // No probe. Key validity is not something this page can learn without
        // spending a provider call, and the call it used to make (a model
        // listing) reported every transport failure as a bad key. The label
        // below reflects the verdict recorded by REAL chat traffic instead, so
        // it only ever says "Invalid API Key" when the provider actually said
        // the key was the problem.
        aiModelsError.value = apiKeyRejected(serviceId, platform);
    } catch {
        if (token !== aiPlatformFetchToken || aiPlatform.value !== platform) {
            return;
        }
        aiModels.value = [];
        selectedModel.value = '';
    } finally {
        if (token === aiPlatformFetchToken) {
            fetchingAiModels.value = false;
        }
    }
}

function buildAiAgentValue(platform: string): string {
    return engineBuildAiAgentValue(platform, selectedModel.value, selectedContextWindow.value);
}

watch(aiPlatform, async (platform) => {
    const token = ++aiPlatformFetchToken;

    if (platform === 'none') {
        aiApiKey.value = '';
        aiModels.value = [];
        selectedModel.value = '';
        aiModelsError.value = false;
        fetchingAiApiKey.value = false;
        fetchingAiModels.value = false;
        await currentService.value.setServiceOption({ ai_agent: 'none' });
        return;
    }

    aiApiKey.value = '';
    aiModels.value = [];
    selectedModel.value = '';
    aiModelsError.value = false;
    fetchingAiApiKey.value = true;
    fetchAiModels(platform as 'claude' | 'openai', token);

    let serviceId = currentService.value.id;

    // check lightweight cache first
    let cachedKey = aiApiKeyCache[serviceId]?.[platform as 'claude' | 'openai'];
    if (cachedKey) {
        if (token !== aiPlatformFetchToken || aiPlatform.value !== platform) {
            return;
        }
        aiApiKey.value = cachedKey;
        await currentService.value.setServiceOption({ ai_agent: buildAiAgentValue(platform) });
        if (token === aiPlatformFetchToken) {
            fetchingAiApiKey.value = false;
        }
        return;
    }

    // check the shared client-secrets pager if it has this key cached already
    let pager = serviceClientSecrets[serviceId];
    if (pager?.list?.[platform]?.client_secret) {
        aiApiKey.value = pager.list[platform].client_secret;
        aiApiKeyCache[serviceId] = {
            ...(aiApiKeyCache[serviceId] || {}),
            [platform]: aiApiKey.value,
        };
        await currentService.value.setServiceOption({ ai_agent: buildAiAgentValue(platform) });
        if (token === aiPlatformFetchToken) {
            fetchingAiApiKey.value = false;
        }
        return;
    }

    // The visit-time prefetch (main.vue run) may already be fetching this key —
    // await the shared request so we reuse its result instead of firing a
    // duplicate (same as agent.vue's refreshGate).
    const inflight = aiApiKeyInflight[serviceId + '#' + platform];
    if (inflight) {
        try { await inflight; } catch { /* prefetch is best-effort */ }
        if (token !== aiPlatformFetchToken || aiPlatform.value !== platform) {
            return;
        }
        const prefetched = aiApiKeyCache[serviceId]?.[platform as 'claude' | 'openai'];
        if (prefetched) {
            aiApiKey.value = prefetched;
            await currentService.value.setServiceOption({ ai_agent: buildAiAgentValue(platform) });
            if (token === aiPlatformFetchToken) {
                fetchingAiApiKey.value = false;
            }
            return;
        }
    }

    // fetch from network (filtered by platform). Do not pollute the shared
    // client-secrets pager with a filtered result; cache into aiApiKeyCache.
    try {
        let result = await currentService.value.listClientSecrets(false, platform);
        if (token !== aiPlatformFetchToken || aiPlatform.value !== platform) {
            return;
        }

        let match = result.list?.find(cs => cs.id === platform);
        if (match?.key) {
            aiApiKey.value = match.key;
            aiApiKeyCache[serviceId] = {
                ...(aiApiKeyCache[serviceId] || {}),
                [platform]: match.key,
            };
            await currentService.value.setServiceOption({ ai_agent: buildAiAgentValue(platform) });
        } else {
            // No key saved for this platform yet. Keep the user's selection so
            // they can add a key via the Edit modal; do not silently revert to 'none'.
            aiApiKey.value = '';
            await currentService.value.setServiceOption({ ai_agent: buildAiAgentValue(platform) });
        }
    } catch {
        if (token !== aiPlatformFetchToken || aiPlatform.value !== platform) {
            return;
        }
        aiApiKey.value = '';
    } finally {
        if (token === aiPlatformFetchToken) {
            fetchingAiApiKey.value = false;
        }
    }
});

onMounted(() => {
    removeFullScreenLoader();
    syncMobile();
    const saved = currentService.value.service.ai_agent || '';
    const [platform, model] = saved.includes('#') ? saved.split('#') : [saved, ''];
    if (model) selectedModel.value = model;
    aiPlatform.value = (platform && platform !== 'none') ? platform : 'none';
    window.addEventListener('click', closeAiPlatformMenu);
    window.addEventListener('click', closeModelMenu);
    window.addEventListener('click', closeUploadAccessMenu);
    window.addEventListener('resize', syncMobile);
    // Two network reads the rest of the page does not wait on.
    probeWidgetVersions();
});

onUnmounted(() => {
    window.removeEventListener('click', closeAiPlatformMenu);
    window.removeEventListener('click', closeModelMenu);
    window.removeEventListener('click', closeUploadAccessMenu);
    window.removeEventListener('resize', syncMobile);
    if (widgetCopyTimer) clearTimeout(widgetCopyTimer);
});

let canDeleteService = computed(() => {
    return (
        (currentService.value.service.active < 0 &&
            currentService.value.service.active > -999) ||
        currentService.value.formattedSpecs.currentPlan.label === "Free" ||
        currentService.value.formattedSpecs.currentPlan.label === "Unlimited" ||
        currentService.value.service?.will_terminate ||
        currentService.value.subscription?.will_cancel
    );
});

let editName = () => {
    inputName = currentService.value.service.name;
    modifyMode.name = true;
    nextTick(() => {
        focus_name.value.focus();
    });
};
let changeName = () => {
    if (currentService.value.service.name !== inputName) {
        let regex = /[<>`]/g;
        if (inputName.match(regex)) {
            alert("Angle brackets and backticks are not allowed");
            return;
        }

        let previous = currentService.value.service.name;
        updatingValue.name = true;

        currentService.value
            .setServiceOption({ name: inputName })
            .then(() => {
                updatingValue.name = false;
                currentService.value.service.name = inputName;
                modifyMode.name = false;
            })
            .catch((err) => {
                if (!(err instanceof SkapiError)) throw err;
                updatingValue.name = false;
                currentService.value.service.name = previous;
            });
    } else {
        updatingValue.name = false;
        currentService.value.service.name = inputName;
        modifyMode.name = false;
    }
};

let editCors = () => {
    inputCors =
        currentService.value.service.cors === "*"
            ? ""
            : currentService.value.service.cors;
    modifyMode.cors = true;
    nextTick(() => {
        focus_cors.value.focus();
    });
};
let changeCors = () => {
    updatingValue.cors = true;
    currentService.value
        .setServiceOption({ cors: inputCors })
        .then(() => {
            updatingValue.cors = false;
            modifyMode.cors = false;
        })
        .catch((err) => {
            if (!(err instanceof SkapiError)) throw err;
            updatingValue.cors = false;
            nextTick(() => {
                let modifyCorsEl = document.getElementById("modifyCors") as HTMLInputElement;
                if (modifyCorsEl) {
                    modifyCorsEl.focus();
                    modifyCorsEl.setCustomValidity(err.message);
                    modifyCorsEl.reportValidity();
                }
            });
        });
};

let editDescription = () => {
    inputDescription = currentService.value.service.description || "";
    modifyMode.description = true;
    nextTick(() => {
        focus_description.value?.focus();
    });
};
let changeDescription = () => {
    updatingValue.description = true;
    let desc = inputDescription.trim();
    currentService.value
        .setServiceOption({ description: desc })
        .then(() => {
            updatingValue.description = false;
            currentService.value.service.description = desc;
            modifyMode.description = false;
        })
        .catch((err) => {
            if (!(err instanceof SkapiError)) throw err;
            updatingValue.description = false;
        });
};

let changeCreateUserMode = async (onlyAdmin: boolean) => {
    updatingValue.prevent_signup = true;
    currentService.value
        .setServiceOption({ prevent_signup: onlyAdmin })
        // .catch((err) => {
        //     if (!(err instanceof SkapiError)) throw err;
        //     alert(err.message);
        // })
        .finally(() => {
            updatingValue.prevent_signup = false;
        });
};

let enableDisable = async () => {
    updatingValue.enableDisable = true;
    try {
        if (currentService.value.service.active >= 1)
            await currentService.value.disableService();
        else await currentService.value.enableService();
    } 
    // catch (err) {
    //     if (!(err instanceof SkapiError)) throw err;
    //     window.alert(err.message);
    // } 
    finally {
        updatingValue.enableDisable = false;
    }
};

let changePreventInquiry = async (onlyAdmin: boolean) => {
    updatingValue.prevent_inquiry = true;
    currentService.value
        .setServiceOption({ prevent_inquiry: onlyAdmin })
        // .catch((err) => {
        //     if (!(err instanceof SkapiError)) throw err;
        //     alert(err.message);
        // })
        .finally(() => {
            updatingValue.prevent_inquiry = false;
        });
};

let changeFreezeDatabase = async (onlyAdmin: boolean) => {
    updatingValue.freeze_database = true;
    currentService.value
        .setServiceOption({ freeze_database: onlyAdmin })
        // .catch((err) => {
        //     if (!(err instanceof SkapiError)) throw err;
        //     alert(err.message);
        // })
        .finally(() => {
            updatingValue.freeze_database = false;
        });
};

/* ─── upload access defaults (Advanced > Upload access) ─── */
// The value lives in a record of the project's OWN database ("bq::settings" in
// "__SETTINGS__", public), not on the service record, so it has to be fetched
// before the control can show it and written with postRecord when it changes.
// See @/code/access_group for why it moved.
// The three groups, plus "Ask every time". One control, because "ask" is not a
// group you can also hold a default for: it IS the answer to "which group", and
// the answer is "do not decide here".
const uploadAccessOptions = [
    ...UPLOAD_ACCESS_OPTIONS,
    {
        value: 'ask',
        label: 'Ask every time',
        hint: 'Pick the access for each file as you upload it.',
    },
];
// The engine's store is a plain Map, not a reactive one: it is shared with the
// widget and must not depend on Vue. So the page mirrors the two things the
// template needs into refs of its own, and is the only writer of both.
//
// `uploadAccessStored` is the RAW setting: null when the project has never set
// one, which is a distinction this page (unlike every upload path) needs. See
// selectUploadAccessGroup's no-op guard.
// `projectSettingsLoaded` separates "fetched, and there is none" from "not fetched
// yet". The control stays disabled until it flips, because the sync accessors
// answer with the default before the fetch settles and the guard below would
// then read a value nobody stored as one the user already has.
let uploadAccessStored = ref<ProjectAccessSetting | null>(null);
// Covers BOTH settings held in the bq::settings record: they are read by the one
// fetch in onMounted and settle together, so a second flag could only ever be a
// copy of this one that is wrong while it disagrees.
let projectSettingsLoaded = ref(false);

// The project's custom chat opening line, "" when it has never set one (which
// is what makes the chat use the built-in sentence). Same record and the same
// single fetch as the access group above.
let chatGreetingStored = ref("");
let inputChatGreeting = ref("");

onMounted(async () => {
    const service = currentService.value?.id || "";
    if (!service) return;
    // Never rejects: the store settles a failed read as "no record".
    await readyProjectSettings(service);
    // Guard a project switch that happened while this was in flight. This view
    // does remount per project, but the await is long enough to outlive one.
    if ((currentService.value?.id || "") !== service) return;
    uploadAccessStored.value = projectAccessSetting(service);
    projectSettingsLoaded.value = true;
    // One fetch, both settings: cachedProjectSettings is settled by the await
    // above, so this is a map read rather than a second request.
    chatGreetingStored.value = chatGreetingFrom(cachedProjectSettings(service));
});

/** What the row shows: the project's own line, or the built-in one named. */
const chatGreetingLabel = computed(
    () => chatGreetingStored.value || "Default intro message",
);

let editChatGreeting = () => {
    // The .disabled class already blocks the pointer; this is the same guard one
    // layer in, so no other caller can open the modal onto a value we have not
    // fetched yet. Same shape as selectUploadAccessGroup's.
    if (!projectSettingsLoaded.value) return;
    inputChatGreeting.value = chatGreetingStored.value;
    modifyMode.chatGreeting = true;
    nextTick(() => {
        focus_chatGreeting.value?.focus();
    });
};

/**
 * Save the custom opening line. An EMPTY box is a valid save, not a no-op: it
 * is how an owner goes back to the built-in sentence, so "" is written to the
 * record and every client reads it as unset.
 */
let changeChatGreeting = async () => {
    const service = currentService.value?.id || "";
    if (!service) return;
    // Normalised with the SAME function the clients read it back through, so
    // what the row shows after saving cannot differ from what the chat opens
    // with (trimmed, blank-line runs collapsed, capped).
    const next = normalizeChatGreeting(inputChatGreeting.value);
    if (next === chatGreetingStored.value) {
        modifyMode.chatGreeting = false;
        return;
    }
    updatingValue.chatGreeting = true;
    try {
        await saveProjectSetting(service, { chat_greeting: next });
        // patch, not set: the record also holds upload_access_group.
        patchProjectSettings(service, { chat_greeting: next });
        chatGreetingStored.value = next;
        modifyMode.chatGreeting = false;
    } catch (err) {
        if (err instanceof SkapiError) alert(err.message);
        else throw err;
    } finally {
        updatingValue.chatGreeting = false;
    }
};

// null when the project has never set one. Shown as the effective default rather
// than as blank, since that is what an upload would actually use.
const uploadAccessSetting = computed(
    () => uploadAccessStored.value || DEFAULT_UPLOAD_ACCESS_GROUP,
);
const uploadAccessLabel = computed(() => {
    const found = uploadAccessOptions.find((o) => o.value === uploadAccessSetting.value);
    return found ? found.label : UPLOAD_ACCESS_LABELS[DEFAULT_UPLOAD_ACCESS_GROUP];
});

const uploadAccessMenuOpen = ref(false);
const toggleUploadAccessMenu = () => {
    if (isMobile.value) return;
    aiPlatformMenuOpen.value = false;
    modelMenuOpen.value = false;
    contextMenuOpen.value = false;
    uploadAccessMenuOpen.value = !uploadAccessMenuOpen.value;
};
const closeUploadAccessMenu = () => {
    uploadAccessMenuOpen.value = false;
};

const selectUploadAccessGroup = async (raw: string) => {
    uploadAccessMenuOpen.value = false;
    const service = currentService.value?.id || "";
    if (!service || !projectSettingsLoaded.value) return;
    const next: ProjectAccessSetting = raw === 'ask' ? 'ask' : normalizeUploadAccessGroup(raw);
    // Compared against the RAW setting, which is null when the project has never
    // set one. uploadAccessSetting DISPLAYS the fallback ('authorized'), so
    // comparing against that made picking the displayed value a no-op: the row
    // read "Signed in users" while the stored setting stayed empty and every
    // client kept falling back, and the owner had no way to correct it.
    if (next === uploadAccessStored.value) return;
    updatingValue.uploadAccess = true;
    try {
        await saveProjectSetting(service, { upload_access_group: next });
        // Adopt what we just wrote rather than re-fetching it: the writer knows
        // the stored value, and leaving the store unsettled would send the next
        // upload back to the network for a value already in hand. patch, not
        // set: the record holds an object and a future setting must survive
        // this save.
        patchProjectSettings(service, { upload_access_group: next });
        uploadAccessStored.value = next;
    } catch (err) {
        // Loud, because the control would otherwise go on showing the value the
        // owner picked while the stored setting says something else, and the
        // thing it decides is who can read their files.
        if (err instanceof SkapiError) alert(err.message);
        else throw err;
    } finally {
        updatingValue.uploadAccess = false;
    }
};

/**
 * Write ONE OR MORE keys into the project's settings record, creating it the
 * first time and updating it after. Shared by every setting stored there (the
 * upload access group, the chat intro line), which is the whole point of the
 * record holding an object.
 *
 * postRecord HAS NO UPSERT. A second save of the same unique_id fails with "is
 * already taken", so without the second half of this the setting could be
 * changed exactly once per project and every later save would throw. Same
 * create-then-settle-as-an-update shape ai_agent's upsertIndexRunRecord uses,
 * for the same reason.
 *
 * The update posts by RECORD_ID and names no table: under the SDK's rule an
 * update that carries no table leaves the record where it is, so the settings
 * record cannot be walked out of the public group by a save that only meant to
 * change a value.
 */
const saveProjectSetting = async (service: string, patch: ProjectSettingsData) => {
    try {
        await (skapi as any).postRecord(patch, {
            service,
            unique_id: PROJECT_SETTINGS_UNIQUE_ID,
            table: { name: PROJECT_SETTINGS_TABLE, access_group: PROJECT_SETTINGS_ACCESS_GROUP },
        });
        return;
    } catch (err: any) {
        // Anything that is NOT the record already existing is a real failure and
        // belongs to the caller: a permission problem must not be retried as an
        // update against a record id we do not have.
        if (String(err?.message || err || '').indexOf('is already taken') === -1) throw err;
    }
    const found: any = await (skapi as any).getRecords({ service, unique_id: PROJECT_SETTINGS_UNIQUE_ID });
    const rec = found?.list?.[0];
    // Taken, but unreadable. Re-throwing the original "is already taken" would
    // name the wrong problem, so say what actually happened.
    if (!rec?.record_id) throw new Error('The project settings record exists but could not be read back, so the setting was not saved.');
    // MERGE, never replace. `data` on this record is a settings OBJECT, and the
    // whole reason it is one record rather than one record per setting is that a
    // second setting is a new KEY here. postRecord replaces `data` wholesale, so
    // posting the patch alone would silently delete every other key the moment
    // one exists. Merged over the record we just read back rather than over the
    // cache: this is the stored state, and it is fresher than anything this tab
    // may have been holding since the page loaded.
    const merged = Object.assign({}, rec.data && typeof rec.data === 'object' ? rec.data : {}, patch);
    await (skapi as any).postRecord(merged, { service, record_id: rec.record_id });
};

/**
 * Unset means TRUE: a project that has never touched this keeps the login wall
 * it has always had. Only an explicit `false` opens the chat, matching
 * aiClientSecretGrp so the flag and the key can never disagree about which way
 * they fail.
 */
const requireLogin = computed(() => currentService.value?.service?.require_login !== false);

let changeRequireLogin = async (requireIt: boolean) => {
    updatingValue.require_login = true;
    try {
        await currentService.value.setServiceOption({ require_login: requireIt });
        // The service flag alone does not open the chat. `client_secret_key_request`
        // refuses an unauthenticated caller whenever the AI key's own access group
        // is non-zero, so the key has to move with the setting or the toggle is
        // cosmetic: anonymous visitors would reach a chat whose every send is
        // rejected with "No access to client secret."
        anonymousKeyWarning.value = "";
        const failed = await syncAiClientSecretGrp();
        if (failed.length) {
            anonymousKeyWarning.value =
                "The setting was saved, but the AI key could not be moved: " + failed.join("; ");
        }
    } finally {
        updatingValue.require_login = false;
    }
};

/**
 * Re-register the project's AI key under the access group the current
 * "Require login" setting implies. `req: 'update'` needs only the id, so
 * the key VALUE is never re-sent (and never has to be read back out of storage).
 *
 * Best effort on purpose: a project with no key configured yet has nothing to
 * move, and that is the common case when the toggle is first switched on. The
 * next saveAiApiKey writes the right group anyway, since it reads the same rule.
 */
let syncAiClientSecretGrp = async (): Promise<string[]> => {
    const grp = aiClientSecretGrp(currentService.value);
    const failed: string[] = [];

    // Which platforms actually HAVE a row in the client-secret table. Asked
    // rather than assumed: `req: 'update'` on a platform that never saved a key
    // answers NOT_EXISTS, and a project whose key lives in the older
    // service-record `client_secret` map has no row here at all. Listing first
    // turns "nothing to move" into a no-op instead of an error the owner sees.
    let existing: string[] = [];
    try {
        const res: any = await currentService.value.listClientSecrets();
        const list = res?.list || [];
        existing = list.map((c: any) => c?.id).filter(Boolean);
    } catch (err: any) {
        // Could not enumerate: fall back to attempting both, which is what this
        // did before, and let the per-platform catch below sort it out.
        existing = ["claude", "openai"];
    }
    // BOTH platforms, not just the selected one. A project that used Claude,
    // switched to OpenAI, then turned the login requirement back on would
    // otherwise leave the Claude key at group 0 forever: still resolvable by an
    // unauthenticated caller, still spending the owner's API budget, with the
    // dashboard reporting anonymous access as disabled. A key that does not
    // exist for a platform simply reports NOT_EXISTS and is skipped.
    for (const platform of ["claude", "openai"]) {
        if (existing.indexOf(platform) === -1) continue;
        try {
            await currentService.value.registerClientSecret({
                id: platform,
                grp,
                req: "update",
            });
        } catch (err: any) {
            // Matched on the CODE, not on `instanceof SkapiError`: this rejects
            // with a plain { code, message } object, so an instanceof test is
            // false for exactly the NOT_EXISTS case it was meant to skip and
            // rethrows it at the toggle, which then reports
            // 'Client secret key "claude" does not exist.' for a project that
            // simply never saved a key for that platform.
            const code = err?.code || "";
            if (code === "NOT_EXISTS") continue;
            // Anything else is a real failure to move the key, and the toggle
            // must not claim success: the flag is saved but the key still
            // refuses (or still accepts) anonymous callers.
            failed.push(platform + ": " + (err?.message || code || "unknown error"));
        }
    }
    return failed;
};

const barColor = (percent: string) => {
    const n = Number(percent.toString().replace("%", ""));
    if (!n) return "";
    // Past 100 on a plan that bills instead of stopping is not a danger, it
    // is a charge: colour it as information, not as a warning.
    if (n > 100 && currentService.value?.formattedSpecs?.currentPlan?.hard_stop === false) return "bq-bar--over";
    if (n >= 80) return "bq-bar--danger";
    if (n >= 50) return "bq-bar--warn";
    return "";
};

// The stacked file pool bar keeps its segment colours whatever the level; the
// TRACK carries the state instead: a warning ring near the ceiling, a danger
// ring on a hard stop plan that has hit it, an informational ring on an overage
// plan past it.
const poolTrackClass = (percent: string) => {
    const n = Number(percent.toString().replace("%", ""));
    if (!n) return "";
    if (n > 100 && currentService.value?.formattedSpecs?.currentPlan?.hard_stop === false) return "bq-bar--over";
    if (n >= 100) return "bq-bar--danger";
    if (n >= 80) return "bq-bar--warn";
    return "";
};

// Usage can exceed the limit on a plan without a hard stop, and a fill wider
// than its track paints over the layout. The number beside the bar still says
// how far over it is.
const barWidth = (percent: string) => {
    const n = Number(percent.toString().replace("%", ""));
    if (!Number.isFinite(n) || n <= 0) return "0%";
    return `${Math.min(n, 100)}%`;
};

let editAiApiKey = async () => {
    if (aiPlatform.value === 'none' || fetchingAiApiKey.value || loadingAiApiKey.value) return;
    let value = aiApiKey.value || '';
    if (!value && (aiPlatform.value === 'claude' || aiPlatform.value === 'openai')) {
        loadingAiApiKey.value = true;
        startAiApiKeyDots();
        try {
            value = (await loadAiApiKeyPrivately(aiPlatform.value)) || '';
        } finally {
            loadingAiApiKey.value = false;
            stopAiApiKeyDots();
        }
    }
    inputAiApiKey = value;
    modifyMode.aiApiKey = true;
    nextTick(() => {
        focus_aiApiKey.value?.focus();
    });
};

let saveAiApiKey = async () => {
    let key = inputAiApiKey.trim();
    if (!key) return;

    updatingValue.aiApiKey = true;
    try {
        let isUpdate = !!aiApiKey.value;
        await currentService.value.registerClientSecret({
            id: aiPlatform.value,
            key,
            // Tracks "Allow anonymous users": a locked (grp 1) key makes the
            // backend refuse every unauthenticated chat send. See aiClientSecretGrp.
            grp: aiClientSecretGrp(currentService.value),
            req: isUpdate ? 'update' : 'create',
        });
        await currentService.value.setServiceOption({ ai_agent: buildAiAgentValue(aiPlatform.value) });
        aiApiKey.value = key;
        modifyMode.aiApiKey = false;

        // sync lightweight cache used by dashboard and agent page
        let serviceId = currentService.value.id;
        aiApiKeyCache[serviceId] = {
            ...(aiApiKeyCache[serviceId] || {}),
            [aiPlatform.value]: key,
        };

        // Persist the last key privately so we can prefill the API-key
        // input next time the user opens it on another surface.
        if (aiPlatform.value === 'claude' || aiPlatform.value === 'openai') {
            void saveAiApiKeyPrivately(serviceId, aiPlatform.value, key);
        }

        // sync pager cache only if it already exists (client_secret page was visited)
        let pager = serviceClientSecrets[serviceId];
        if (pager) {
            let mapped = {
                name: aiPlatform.value,
                client_secret: key,
                locked: true,
            };
            if (isUpdate && pager.list[aiPlatform.value]) {
                await pager.editItem(mapped);
            } else {
                await pager.insertItems([mapped]);
            }
        }

        // Now that we have a (potentially new) API key, refetch the model list.
        // The previous fetch may have failed (showing "Invalid API Key") so we
        // must invalidate the shared cache before triggering the refetch.
        // We await the refetch so we can surface an "invalid API key" alert
        // when the platform rejects the new key.
        if (aiPlatform.value === 'claude' || aiPlatform.value === 'openai') {
            const platform = aiPlatform.value;
            // The key just changed, so any recorded verdict describes the OLD
            // key and must be dropped, or a good key inherits "Invalid API Key".
            invalidateApiKeyVerdict(currentService.value.id, platform);
            aiModelsError.value = false;
            const token = ++aiPlatformFetchToken;
            await fetchAiModels(platform, token);
            // Deliberately NOT validated here. Validating meant spending a
            // provider call whose failure modes (queue, proxy, timeout, rate
            // limit, outage) are indistinguishable from a bad key, so a working
            // key was regularly reported as invalid. A wrong key now surfaces
            // where it actually matters: the first chat message returns the
            // provider's own key error, which raises the overlay in the chat.
        }
    } 
    // catch (err: any) {
    //     if (!(err instanceof SkapiError)) throw err;
    //     alert(err.message || err);
    // } 
    finally {
        updatingValue.aiApiKey = false;
    }
};
</script>

<style lang="less" scoped>
@import "@/assets/less/bq-tokens.less";

.bq-dashboard {
    font-family: @mono;
    color: @ink;
}

.bq-dash-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 1.5rem;
    gap: 1rem;
    // padding: 0 0 0 0.5rem;
}

.bq-dash-title {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.4rem;
    min-width: 0;
}

.bq-title {
    font-size: 1.1rem;
    font-weight: 600;
    // margin: 0;
    margin: 0.35rem 0;
    letter-spacing: -0.01em;
    word-break: break-word;
    // padding-left: .5rem;
}

// .bq-upgrade-btn {
//     display: inline-block;
//     font-size: 0.82rem;
//     color: @paper;
//     text-decoration: none;
//     padding: 0.5rem 1rem;
//     border: 1px solid @ink;
//     background: @ink;
//     transition: background 0.15s, color 0.15s;
//     margin-top: 1rem;
//     align-self: flex-end;

//     &:hover {
//         background: @paper;
//         color: @ink;
//     }
// }

/* --- chat link card (top of page) --- */
// Carries the same extruded border+shadow as .bq-meta so it reads as part of
// the page, but on the pink surface so the eye lands on it first.
.bq-share {
    margin-bottom: 1.5rem;
    border: 1px solid @line;
    // background: @pink-bg;
    padding: 1rem;
    box-shadow: 2px 2px var(--bq-shadow);
}

.bq-share-head {
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
    margin-bottom: 0.85rem;
}

.bq-share-title {
    font-size: 1.1rem;
    font-weight: 700;
    color: @ink;
}

.bq-share-hint {
    font-size: 0.75rem;
    color: @muted;
    line-height: 1.4;
}

.bq-share-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    flex-wrap: wrap;
    border: 1px solid @line;
    background: @paper;
    padding: 0.55rem 0.5rem 0.55rem 0.75rem;
}

// The address itself. It is the whole point of the card, so it gets the largest
// type on it and, on a narrow bar, the whole first line.
.bq-share-url {
    // flex: 1 1 14rem;
    min-width: 0;
    font-family: @mono;
    font-size: 0.95rem;
    // font-weight: 600;
    color: @pink;
    text-decoration: none;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &:hover {
        text-decoration: underline;
    }

    &.disabled {
        color: @muted;
        pointer-events: none;
        text-decoration: none;
    }
}

.bq-share-actions {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    flex-shrink: 0;
}

// One rule for both the <button> and the <a>: base.less gives every <button>
// the extruded shadow and the hover/press motion, but an anchor gets none of
// it, so the pair would sit at different heights and move differently. Spelling
// both out here keeps them identical whichever element they are.
.bq-share-btn {
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    padding: 0.4rem 0.7rem;
    border: 1px solid @ink;
    background: @ink;
    color: @paper;
    font-family: @mono;
    font-size: 0.78rem;
    font-weight: 600;
    letter-spacing: 0.04em;
    line-height: 1.2;
    text-decoration: none;
    cursor: pointer;
    white-space: nowrap;
    box-shadow: 2px 2px var(--bq-shadow);
    transition: transform 0.12s ease, box-shadow 0.12s ease;

    &:hover {
        text-decoration: none;
    }

    // Only where hover is a real pointer state; a touch screen emulates it on
    // tap and would leave the button stuck raised (same guard as base.less).
    @media (hover: hover) and (pointer: fine) {
        &:hover {
            transform: translate(-1px, -1px);
            box-shadow: 3px 3px var(--bq-shadow);
        }
    }

    &:active {
        transform: translate(2px, 2px);
        box-shadow: none;
        transition-duration: 0.04s;
    }

    // Held for ~1.6s after a copy so the click has a visible answer.
    &.copied {
        border-color: @success;
        background: @success;
        color: @paper;
    }

    &--ghost {
        border-color: @line;
        background: @paper;
        color: @ink;

        &:hover {
            border-color: @ink;
            background: @hover-bg;
            color: @ink;
        }
    }

    &.disabled {
        opacity: 0.45;
        pointer-events: none;
    }
}

.bq-share-btn-icon {
    font-size: 1rem;
    line-height: 1;
}

.bq-share-note {
    display: block;
    margin-top: 0.6rem;
    font-size: 0.72rem;
    color: @muted;
}

.bq-share--empty {
    border-color: @line;
    background: @paper;

    .bq-share-head {
        margin-bottom: 0;
    }
}

@media (max-width: 480px) {
    .bq-share-actions {
        width: 100%;
    }

    .bq-share-btn {
        flex: 1;
        justify-content: center;
    }
}

/* --- sections --- */
.bq-section {
    margin-bottom: 2.5rem;

    &.disabled {
        opacity: 0.5;
        pointer-events: none;
    }
}

.bq-section-title {
    font-size: 1.1rem;
    font-weight: 700;
    margin: 0 0 1.25rem;
    padding-bottom: 0.75rem;
    border-bottom: 1px solid @line;
}

/* --- rows --- */
.bq-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    padding: 0.85rem 0;
    border-bottom: 1px solid @line;
    font-size: 0.85rem;

    &:first-of-type {
        padding-top: 0;
    }

    &:last-of-type {
        border-bottom: none;
        padding-bottom: 0;
    }
}

.bq-row-label {
    min-width: 7rem;
    font-weight: 600;
    font-size: 0.78rem;
    letter-spacing: 0.04em;
    color: @muted;
    text-transform: uppercase;
    flex-shrink: 0;
}

.bq-row-value {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.bq-mono {
    font-family: @mono;
    font-size: 0.82rem;
}

/* --- select --- */
.bq-ai-select {
    position: relative;
    width: 220px;
}

.bq-ai-select-native {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    min-height: 0;
    opacity: 0;
    cursor: pointer;
    z-index: 2;
}

.bq-ai-select-btn {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    padding: 0.45rem 0.75rem;
    border: 1px solid @line;
    background: @paper;
    color: @ink;
    font-family: @mono;
    font-size: 0.82rem;
    cursor: pointer;

    &:not(:disabled):hover,
    &.open {
        border-color: @ink;
    }
}

.bq-ai-select-value {
    display: inline-flex;
    align-items: center;
    gap: 0.45rem;
    min-width: 0;
}

.bq-ai-caret {
    color: @muted;
}

.bq-ai-options {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    right: 0;
    z-index: 20;
    border: 1px solid @line;
    background: @paper;
    box-shadow: 2px 2px var(--bq-shadow);
    display: flex;
    flex-direction: column;
}

.bq-model-options {
    max-height: 240px;
    overflow-y: auto;
}

.bq-ai-option {
    border: 0;
    border-bottom: 1px solid @line;
    background: transparent;
    box-shadow: none;
    width: 100%;
    text-align: left;
    padding: 0.45rem 0.75rem;
    font-family: @mono;
    font-size: 0.82rem;
    color: @ink;
    display: inline-flex;
    align-items: center;
    justify-content: flex-start;
    gap: 0.45rem;
    cursor: pointer;

    &:last-child {
        border-bottom: 0;
    }

    &:hover {
        background: @hover-bg;
    }

    &.active {
        background: @hover-bg;
    }
}

.bq-ai-logo {
    width: 16px;
    height: 16px;
    flex: 0 0 16px;
}

/* --- plan header --- */
.bq-plan-header {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-bottom: 1.5rem;
}

.bq-renew {
    font-size: 0.78rem;
    color: @muted;
}

/* --- meta --- */
.bq-meta {
    margin-bottom: 1.5rem;
    border: 1px solid @line;
    padding: 1rem;
    box-shadow: 2px 2px var(--bq-shadow);
}

.bq-meta-row {
    display: flex;
    justify-content: space-between;
    padding: 0.35rem 0;
    font-size: 0.78rem;

    span:first-child {
        color: @muted;
        min-width: 5rem;
    }

    span:last-child {
        text-align: right;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}

/* --- usage bars --- */
.bq-usage-bars {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.bq-usage-item {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
}

.bq-usage-head {
    display: flex;
    justify-content: space-between;
    font-size: 0.78rem;
    color: @muted;
}

.bq-bar {
    height: 6px;
    background: @line;
    overflow: hidden;
}

.bq-bar-fill {
    height: 100%;
    background: @light-pink;
    transition: width 0.3s ease;

    &.bq-bar--warn {
        background: @warning-border;
    }

    &.bq-bar--danger {
        background: @danger;
    }

    // Over the limit on a plan that bills the excess: informational, not alarming.
    &.bq-bar--over {
        background: @info;
    }
}

// The file pool: three segments of one track. Colours are per bucket and never
// change with the level; the track's ring says how full the pool is.
.bq-bar--stacked {
    display: flex;
    box-sizing: border-box;

    &.bq-bar--warn {
        box-shadow: 0 0 0 1px @warning-border;
    }

    &.bq-bar--danger {
        box-shadow: 0 0 0 1px @danger;
    }

    &.bq-bar--over {
        box-shadow: 0 0 0 1px @info;
    }
}

.bq-bar-seg {
    height: 100%;
    flex: 0 0 auto;
    transition: width 0.3s ease;
}

.bq-bar-seg--host {
    background: @info;
}

.bq-bar-seg--cloud {
    background: @light-pink;
}

.bq-bar-seg--file {
    background: @success;
}

.bq-usage-legend {
    display: flex;
    flex-wrap: wrap;
    gap: 0.35rem 1rem;
    font-size: 0.72rem;
    color: @muted;
}

.bq-legend-item {
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;

    span {
        color: @ink;
    }
}

.bq-legend-dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
}

.bq-plan-cta {
    margin-top: 1rem;
    text-align: right;

    /* Shrink the link to the button it wraps, so nothing but the button takes
       the click. */
    a {
        display: inline-block;
    }
}

/* --- overage (month to date) --- */
.bq-overage {
    margin-top: 1.25rem;
    padding-top: 1rem;
    border-top: 1px solid @line;
}

.bq-overage-title {
    margin: 0 0 0.35rem;
    font-size: 0.78rem;
    font-weight: 600;
    color: @muted;
}

.bq-overage-total {
    border-top: 1px solid @line;
    font-weight: 600;

    span:first-child {
        color: @ink;
    }
}

.bq-overage-note {
    margin: 0.5rem 0 0;
    font-size: 0.78rem;
    color: @muted;

    // The hard stop line stands alone under the meters, with no block above it.
    &.bq-overage-note--alone {
        margin-top: 1rem;
    }
}

/* --- toggle rows --- */
.bq-toggle-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.85rem 0;
    border-bottom: 1px solid @line;
    gap: 1rem;

    &:first-of-type {
        border-top: 0;
        padding-top: 0;
    }

    &:last-of-type {
        border-bottom: 0;
        padding-bottom: 0;
    }
}

.bq-toggle-label {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;

    span {
        font-size: 0.88rem;
        font-weight: 500;
    }
}

.bq-toggle-hint {
    font-size: 0.72rem;
    color: @muted;
    font-weight: 400;
    line-height: 1.4;
}

.bq-api-key-value {
    display: block;
    max-width: 100%;
    min-height: 1.4em;
}

.bq-api-key-slot {
    display: inline-flex;
    align-items: center;
    max-width: 100%;
    min-height: 1.4em;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.bq-api-key-row .bq-toggle-label {
    flex: 1;
    min-width: 0;
}

.bq-danger {
    color: @danger;
    font-size: 0.82rem;
}

/* --- modal (service-specific) --- */
.bq-modal-input {
    width: 100%;
    padding: 0.75rem 1rem;
    border: 1px solid @line;
    background: @paper;
    color: @ink;
    font-family: @mono;
    font-size: 0.9rem;
    outline: none;
    margin-bottom: 0.75rem;
    border-radius: 0;
    transition: border-color 0.15s;

    &::placeholder { color: @placeholder; }
    &:focus { border-color: @ink; }
}

.bq-modal-textarea {
    width: 100%;
    padding: 0.75rem 1rem;
    border: 1px solid @line;
    background: @paper;
    color: @ink;
    font-family: @mono;
    font-size: 0.9rem;
    outline: none;
    margin-bottom: 0.75rem;
    border-radius: 0;
    transition: border-color 0.15s;
    resize: vertical;
    min-height: 4rem;
    word-wrap: break-word;
    overflow-x: hidden;
    white-space: pre-wrap;

    &::placeholder { color: @placeholder; }
    &:focus { border-color: @ink; }
    &:disabled { opacity: 0.5; cursor: default; }
}

.btn {
    width: 100%;
}

.bq-link {
    left: -2px;
    position: relative;
}

/* --- responsive --- */
@media (max-width: 600px) {
    .bq-dash-header {
        flex-direction: column;
        gap: 1rem;
    }

    .bq-row {
        flex-wrap: wrap;
        gap: 0.25rem 1rem;
    }

    .bq-row-label {
        min-width: 100%;
    }

    .bq-meta-row {
        flex-direction: column;
        gap: 0.15rem;

        span:last-child {
            text-align: left;
        }
    }
}
</style>
